module.exports = __webpack_public_path__ + "img/660-5e2079.png";